import { render, staticRenderFns } from "./lt-from-subtask-modal.vue?vue&type=template&id=c972c5da&scoped=true&"
import script from "./lt-from-subtask-modal.vue?vue&type=script&lang=js&"
export * from "./lt-from-subtask-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c972c5da",
  null
  
)

export default component.exports